import { Toast } from "flowbite-react";
import Dashboard from "../../common/components/layout/Dashboard";
import { ToastProvider } from "../../common/components/ui/toast/toast.provider";
import TableCostCenter from "./components/tables/TableCostCenter";

function PurchaseCostCenterRegister() {
  return (
    <ToastProvider>
      <Dashboard>
        <TableCostCenter />
      </Dashboard>
      <Toast />
    </ToastProvider>
  )
}

export default PurchaseCostCenterRegister;